import { createStore } from 'vuex'

import authState from '@/modules/auth/store'
import dashboardState from '@/modules/dashboard/store'

const store = createStore({
  modules: {
    ...authState,
    ...dashboardState,
  },
  strict: process.env.DEBUGGING
})

export default store
export { store }
